import { Checkbox, ListItemText, MenuItem, Select } from "@mui/material";

interface Option {
  label: string;
  value: string;
}

interface CustomDropdownProps {
  disabled?: boolean;
  isMulti?: boolean;
  options: Option[];
  selectedValues: string[];
  onChange: (newValues: string[]) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 5;
const MenuProps = {
  PaperProps: {
    style: {
      color: 'black',
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

export default function CustomDropdown({ isMulti = true, options, selectedValues, onChange, placeholder = "Select an option", style, disabled }: CustomDropdownProps) {
  return (
    <Select
      multiple={isMulti}
      disabled={disabled}
      displayEmpty
      value={selectedValues}
      onChange={(event) => {
        let values;
        if (isMulti) {
          values = event.target.value as string[];
        } else {
          values = [event.target.value as string];
        }
        onChange(values);
      }}
      MenuProps={MenuProps}
      renderValue={(selected) => {
        if (selected.length === 0) {
          return placeholder;
        }
        return selected
          .map(val => options.find(opt => opt.value === val)?.label || val)
          .join(', ');
      }}
      sx={{
        width: '100%',
        height: 30,
        backgroundColor: 'transparent',
        color: '#374957',
        fontSize: 14,

        '&.Mui-disabled': {
          color: `#37495780`,
          WebkitTextFillColor: `#37495780 !important`,
          opacity: 1,
        },

        '& .MuiSelect-select.Mui-disabled': {
          WebkitTextFillColor: `#37495780 !important`,
        },

        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent !important',
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },

        '& .MuiSelect-icon': {
          color: '#374957',
        },

        '& .MuiSelect-icon.Mui-disabled': {
          color: '#37495780',
          opacity: 0.3,
        },

        ...style,
      }}
    >
      {options.map((option) => {
        const isSelected = selectedValues.includes(option.value);

        return (
          <MenuItem key={option.value} value={option.value}>
            <Checkbox checked={isSelected} style={{ pointerEvents: 'none' }} />

            <ListItemText
              primary={option.label}
              primaryTypographyProps={{
                fontWeight: isSelected ? 'bold' : 'normal',
              }}
            />
          </MenuItem>
        );
      })}
    </Select>
  );
}